// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"132":"71c7202c","243":"79c4a3f1","412":"f47dfb0a"}[chunkId] + ".css";
};